const fromNb = t => t.replace(',', '.').replace('−', '-').replaceAll('&nbsp;', '');
const toNorwegian = (num) => num.toLocaleString('no-NO').replace('-', '−');

export const findInHeader = (word, tableHeader) => {
  const index = [];
  if (Array.isArray(word)) {
    // word.forEach(w => index.concat(findInHeader(w, tableHeader))); //not work
    word.forEach(w => index.push(...findInHeader(w, tableHeader)));
  } else {
    const tr = tableHeader.getElementsByTagName('tr')[0];
    const h = tr.getElementsByTagName('th');
    Array.from(h).forEach((th, i) => {
      if (th.innerHTML.indexOf(word) > -1) index.push(i);
    });
  }
  return index;
};

export const removeColumn = (table, column) => {
  const indexArray = findInHeader(column, table.firstElementChild);
  const columnIndex = (indexArray.length > 0) ? indexArray[0] : null;
  Array.from(table.rows).forEach(tr => tr.cells.item(columnIndex).remove());
};

export const sumRows = (table, filter) => {
  const tableBody = table.getElementsByTagName('tbody')[0];
  const r = tableBody.rows;
  const nr = r.length;
  const nc = r[0]?.cells.length ?? 0;
  const sum = new Array(nc).fill(0);
  for (let i = 0; i < nr; i++) {
    const row = r[i];
    const c = row.cells;
    if (filter && filter !== c[0].innerHTML) continue; // sum only chosen planid
    for (let k = 0; k < nc; k++) {
      const v = fromNb(c[k].innerHTML);
      // sum[k] += +v;
      sum[k] += Number(v);
    }
  }
  return sum.map(v => Math.round(v * 100) / 100);
};

export const addSummaryToTable = (table) => {
  const sum = sumRows(table);
  // const tr = document.createElement('tr');
  const tr = table.insertRow();
  tr.className = 'summary';
  const nc = sum.length;
  sum.forEach((s, i) => {
    const td = document.createElement('td');
    // td.innerHTML = (i < 4) ? ((i === 0) ? 'Sum' : '') : s;
    td.innerHTML = (i < nc - 4) ? '' : toNorwegian(s);
    tr.appendChild(td);
  });
  // table.tBodies[0].appendChild(tr);
};

export const table2csv = (table, emptyColumns) => {
  const rs = [];
  for (let i = 0, row; row = table.rows[i]; i++) {
    const cs = [];
    for (let j = 0, cell; cell = row.cells[j]; j++) {
      // console.log(cell.innerHTML, cell.innerText);
      cs.push('"' + cell.innerText.replaceAll(' ', '') + '"');
    }
    if (emptyColumns) { // add empty columns to be aligned with original table
      const el = emptyColumns.length;
      for (let e = 0; e < el; e++) cs.splice(emptyColumns[e], 0, '');
    }
    rs.push(cs.join(';'));
  }
  return rs.join('\n');
};

export const activateClickInteractions = () => {
  const results = document.getElementById('resultsContent');
  const a = document.getElementById('toggleCurrentEmissions').firstElementChild;
  a.onclick = () => results.classList.toggle('opened');
  const comparisonP = document.getElementById('toggleComparedEmissions');
  const comparisonA = comparisonP.firstElementChild;
  comparisonA.onclick = () => results.classList.toggle('openComparedEmissions');
  const p = document.getElementById('togglePlannedEmissions').firstElementChild;
  p.onclick = () => results.classList.toggle('openPlannedEmissions');
};

export const compareTables = (currentEmissions, plannedEmissions) => {
  const planid = [], sumC = [], sumP = [];
  const currentEmissionsRows = currentEmissions.rows;
  for (let i = 1, row; row = currentEmissionsRows[i]; i++) {
    if (!row.cells[0]) continue;
    const id = row.cells[0].innerHTML;
    if (planid.indexOf(id) > -1 || id === '' || id === 'Sum') continue;
    planid.push(id);
    sumC.push(sumRows(currentEmissions, id));
    sumP.push(sumRows(plannedEmissions, id));
  }
  const piC = findInHeader('Plantegn', currentEmissions.firstElementChild);
  const hiC = findInHeader('Hektar', currentEmissions.firstElementChild);
  const tiC = findInHeader('Tot.', currentEmissions.firstElementChild);
  const selectedColumnsC = piC.concat(hiC).concat(tiC);
  const piP = findInHeader('Plantegn', plannedEmissions.firstElementChild);
  const hiP = findInHeader('Hektar', plannedEmissions.firstElementChild);
  const tiP = findInHeader('Tot.', plannedEmissions.firstElementChild);
  const selectedColumnsP = piP.concat(hiP).concat(tiP);
  const comparedEmissions = document.getElementById('comparedEmissions');
  const tbody = document.createElement('tbody');
  for (let r = 0; r < planid.length; r++) {
    planid[r];
    const tr = document.createElement('tr');
    for (let i = 0; i < selectedColumnsC.length; i++) {
      const td = document.createElement('td');
      if (i === 0) td.innerHTML = planid[r]; // planid
      else {
        const c = sumC[r][selectedColumnsC[i]];
        if (i === 1) td.innerHTML = c.toLocaleString('no-NO'); // hektar
        else {
          const p = sumP[r][selectedColumnsP[i]];
          td.innerHTML = (p - c).toLocaleString('no-NO'); // utslipp
        }
      }
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
  }
  comparedEmissions.lastElementChild.replaceWith(tbody);
  // if (comparedEmissions.rows.length === 3) comparedEmissions.deleteRow(-1);
  if (comparedEmissions.rows.length > 2) addSummaryToTable(comparedEmissions);
  return comparedEmissions;
};

export const totalEmissionsFromTable = (table) => {
  const tableHeader = table.getElementsByTagName('thead')[0];
  const index = findInHeader('Tot.', tableHeader);
  const sumOfRows = sumRows(table).map(x => x.toLocaleString('no-NO'));
  const t5 = `${sumOfRows[index[0]]} tCO<sub>2</sub>`;
  const t20 = `${sumOfRows[index[1]]} tCO<sub>2</sub>`;
  const t75 = `${sumOfRows[index[2]]} tCO<sub>2</sub>`;
  return [t5, t20, t75];
};
